import * as React from 'react';
import { PublicArrowDownOutlined, PublicArrowUpOutlined } from 'notta-web-icon';
import * as styles from '../styles.module.less';
import { Wrapper } from './Header';

import FooterLinkList from './footer-link-list';

const { useState, useEffect } = React;

interface IProps {
  isMediaTool: boolean;
  isNewLayout?: boolean;
}

const Component: React.FC<IProps> = ({ isMediaTool, isNewLayout = false }) => {
  const [open, setOpen] = useState(false);
  const LinkWrapper = Wrapper(isMediaTool);

  useEffect(() => {
    const hideDropDownMenu = () => {
      setOpen(false);
    };
    document.addEventListener('click', hideDropDownMenu);
    return () => {
      document.removeEventListener('click', hideDropDownMenu);
    };
  }, []);

  return (
    <div className={`${styles.footer_container}`}>
      {/* <div className="container-new footer-header w-container" /> */}
      <FooterLinkList isNewLayout={isNewLayout} isMediaTool={isMediaTool} />
      <div className={`${styles.tail} ${isNewLayout && styles.new_home_page_footer}`}>
        <p className="caption-new left-aligned footer">
          🍀 &nbsp;NottaはDX推進・ペーパーレス化に応援します。取材、プレスリリース、レビュー等に関するお問い合わせ:{' '}
          <a href="mailto:contact@notta.ai" className="link-new footer">
            contact@notta.ai{' '}
          </a>
          <br />
          Copyright © 2023 Notta. All Rights Reserved.{' '}
          <LinkWrapper to="/terms" target="_blank" className="link-new footer">
            利用規約
          </LinkWrapper>
          ｜
          <LinkWrapper to="/privacy" target="_blank" className="link-new footer">
            プライバシー
          </LinkWrapper>
          ｜
          <LinkWrapper to="/sitemap" target="_blank" className="link-new footer">
            サイトマップ{' '}
          </LinkWrapper>
          ｜
          <LinkWrapper to="/share-jp" target="_blank" className="link-new footer">
            友達紹介キャンペーン利用規約{' '}
          </LinkWrapper>
          ｜
          <LinkWrapper to="/security" target="_blank" className="link-new footer">
            セキュリティシステム{' '}
          </LinkWrapper>
          <br />
        </p>
        <div className={styles.switch_language_dropdown_container}>
          <div data-delay={0} data-hover="false" className={`dropdown-new language w-dropdown ${styles.dropdown}`}>
            <div
              id="JP_tab"
              data-w-id="7153105d-6a7c-b989-ce8e-ed464f9cf288"
              className="dropdown-toggle-new language w-dropdown-toggle"
              onClick={(event) => {
                event.stopPropagation();
                setOpen(!open);
              }}
            >
              <div className="icon-new language w-embed">
                <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.08302 3.52609C5.51981 4.2839 3.59222 6.52253 3.29107 9.25117C3.30506 9.2504 3.31916 9.25 3.33334 9.25H5.94279C6.09098 7.13 6.86262 5.17131 8.08302 3.52609ZM5.94278 10.75H3.33334C3.31916 10.75 3.30506 10.7496 3.29107 10.7488C3.59222 13.4775 5.51979 15.7161 8.08299 16.4739C6.86259 14.8287 6.09096 12.87 5.94278 10.75ZM10 16.4374C8.54899 14.8738 7.62271 12.9042 7.44711 10.75H12.5529C12.3773 12.9042 11.451 14.8738 10 16.4374ZM10.0032 18.25H10.0047C14.5576 18.2475 18.2478 14.5569 18.25 10.004L18.25 10C18.25 5.44365 14.5563 1.75 10 1.75C5.44365 1.75 1.75 5.44365 1.75 10C1.75 14.5547 5.44094 18.2473 9.99499 18.25C9.99772 18.25 10.0004 18.25 10.0032 18.25ZM7.44712 9.25C7.62273 7.09586 8.549 5.12622 10 3.56257C11.451 5.12622 12.3773 7.09585 12.5529 9.25H7.44712ZM14.0572 9.25C13.909 7.13 13.1374 5.17132 11.917 3.52609C14.4798 4.28379 16.4072 6.52189 16.7088 9.25H14.0572ZM14.0572 10.75C13.909 12.87 13.1374 14.8287 11.917 16.4739C14.4798 15.7162 16.4072 13.4781 16.7088 10.75H14.0572Z"
                    fill="CurrentColor"
                  />
                </svg>
              </div>
              <div className={`${styles.lang}`}>日本語</div>
              {open ? (
                <div className={styles.icon}>
                  <PublicArrowUpOutlined size={16} />
                </div>
              ) : (
                <div className={styles.icon}>
                  <PublicArrowDownOutlined size={16} />
                </div>
              )}
            </div>
            <nav className={`${open ? 'w--open' : ''} dropdown-list-new language w-dropdown-list`}>
              <LinkWrapper to="/en" id="EN_tab" className="dropdown-link-new navigation-bar-new w-dropdown-link">
                English
              </LinkWrapper>
            </nav>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Component;
